module.exports = __webpack_public_path__ + "img/P150T_weapon_4.259fae0e.png";